import { defineStore } from 'pinia';
import axios from 'axios';

export const useSearchStore = defineStore('search', {
  state: () => ({
    active: false,
    query: '',
    results: [],
    loading: false,
  }),
  actions: {
    open() {
      this.active = true;
    },
    close() {
      this.active = false;
      this.query = '';
      this.results = [];
    },
    async search(q) {
      this.query = q;
      if (q.length < 2) {
        this.results = [];
        return;
      }
      this.loading = true;
      try {
        const res = await axios.get('/search', {
          params: { query: q, fields: 'title|text|intro|description' }
        });
        this.results = res.data;
      } catch (e) {
        console.error('Search error:', e);
      } finally {
        this.loading = false;
      }
    },
  },
});
